const initialState =
{
    loading: false,
    error: false,
    message: "",
    code: null,
    comentarios: '',
    idos : null ,
    idseguimiento: null,
    info: [],
    intelisisArticulos:[]

}

export default (state = initialState, action) => {
    switch (action.type) {
        case "GETID_SEGUIMIENTO":
            return { ...state, ...action.payload }
        
        case "SUCCESS_DATA_SEGUIMIENTO":
            return { ...state, ...action.payload, loading:false  }

        case "ERROR_DATA_SEGUIMIENTO":
            return { ...state, ...action.payload, loading: false }

        case "CHANGE_VALUE_FORM":
            return { ...state, ...action.payload }

        case "SAVE_FORM":
            return { ...state, ...action.payload, loading: true, code: null, message: '' }
        
        case "SAVED_FORM":
             return { ...state, ...action.payload, loading: false}

        case "ERROR_SAVED_FORM":
            return { ...state, ...action.payload, loading: false }

        case "SUCCESS_DATA_API_PREORDEN":
            return { ...state, ...action.payload, loading:false  }

        case "ERROR_DATA_API_PREORDEN":
            return { ...state, ...action.payload, loading: false }
        
        case "READY_ARTICULOS_INTELISIS":
            return{ ...state,intelisisArticulos:action.payload}
        
        case "NO_DATA_INTELISIS_ARTICULOS":
            return { ...state,intelisisArticulos:[]}

        default:

    }
    return state;
}